import * as React from "react";
import { RxSocket } from "src/share/services/rxjsSocket";
interface ISubscriberProps<T> {
  serverUrl: string;
  path: string;
  event: string
  children: (data: T) => React.ReactNode;
}
interface ISubscriberState<T> {
  data: T
}
export class Subscriber<T = any> extends React.PureComponent<ISubscriberProps<T>, ISubscriberState<T>> {
  private socket: RxSocket<T>;
  constructor(props) {
    super(props);
    this.state = { data: {} as T }
    this.setRXJS()
  }
  public setRXJS() {
    this.socket = new RxSocket(this.props.serverUrl, { path: this.props.path });
  }
  public componentDidUpdate(prevProps) {
    if (this.props.serverUrl !== prevProps.serverUrl) {
      this.disconnect();
      this.setRXJS()
      this.connect();
    }
  }
  public componentDidMount() {
    this.connect();
  }
  public connect() {
    const server = this.socket.subject(this.props.event);
    server.subscribe((data) => {
      this.setState({ data })
    });
  }
  public disconnect() {
    this.socket.disconnect();
  }
  public componentWillUnmount() {
    this.disconnect();
  }
  public render() {
    return this.props.children(this.state.data)
  }
}